// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import { gql } from 'graphql-tag';
export const ComponentOnThisPageFragmentDoc = gql`
    fragment componentOnThisPage on ComponentOnThisPage {
  __typename
}
    `;